import { render, staticRenderFns } from "./headTitle.vue?vue&type=template&id=38d7d352&scoped=true&"
import script from "./headTitle.vue?vue&type=script&lang=js&"
export * from "./headTitle.vue?vue&type=script&lang=js&"
import style0 from "./headTitle.vue?vue&type=style&index=0&id=38d7d352&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7d352",
  null
  
)

export default component.exports